/* eslint-disable prefer-destructuring */
import React, { Component } from 'react';
import { List, Button, Input, Label } from 'semantic-ui-react';
import { cleanDomainName } from '../../../utils/urls';
import * as API from '../../../utils/api';

class DomainSearchForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      domain: '',
      loading: false,
      results: [],
      numShowResults: 5,
      numShowIncrement: 5,
    };

    this.searchDomains = this.searchDomains.bind(this);
    this.handleDomainChange = this.handleDomainChange.bind(this);
    this.handleDomainClick = this.handleDomainClick.bind(this);
    this.showMoreResults = this.showMoreResults.bind(this);
  }

  async componentDidMount() {
    const { defaultDomain } = this.props;
    this.setState({ domain: defaultDomain }, async () => {
      await this.searchDomains();
    });
  }

  searchDomains() {
    const re = /[^.]*\.[^.]{2,3}(?:\.[^.]{2,3})?$/;
    const { domain } = this.state;
    const match = domain.match(re);
    let finalDomain;

    if (!match) {
      finalDomain = `${domain}.com`;
    } else {
      finalDomain = match[0];
    }

    this.setState({ loading: true }, async () => {
      try {
        const resp = await API.searchDomains(finalDomain);
        const { data } = resp;
        this.setState({
          loading: false,
          results: data,
        });
      } catch (e) {
        this.setState({ loading: false });
      }
    });
  }

  handleDomainChange(e, { value }) {
    this.setState({ domain: cleanDomainName(value) });
  }

  showMoreResults() {
    const { numShowResults, numShowIncrement, results } = this.state;

    const nextNumShowResults =
      results.length > numShowResults + numShowIncrement
        ? numShowResults + numShowIncrement
        : results.length;

    this.setState({ numShowResults: nextNumShowResults });
  }

  handleDomainClick(domain) {
    const { onDomainSelected } = this.props;

    if (domain.Availability === 'AVAILABLE') {
      onDomainSelected(domain);
    }
  }

  render() {
    const { results, domain, loading, numShowResults } = this.state;
    const { onHasCustomDomainChanged } = this.props;

    return (
      <React.Fragment>
        <Input
          className="domain-search-input"
          type="text"
          placeholder="Find Domain"
          labelPosition="left"
          value={domain}
          onChange={this.handleDomainChange}
        >
          <Label className="https-label domain-search-input-consistent-padding">https://</Label>
          <input
            className="borderless-input domain-search-input-consistent-padding"
            value={domain}
          />
          <Button
            className="domain-search-button"
            type="submit"
            onClick={this.searchDomains}
            loading={loading}
          >
            Search
          </Button>
        </Input>
        <Button
          id="custom-domain-connect-button"
          className="publish-now-from-request-button extra-margin centered-content blue-color"
          onClick={() => onHasCustomDomainChanged()}
        >
          I already own a domain to connect
        </Button>
        {results.length > 0 && (
          <h3 className="header-text blue-color domain-search-header">Suggested results:</h3>
        )}
        <List className="domain-results" divided verticalAlign="middle">
          {results.slice(0, numShowResults).map((result, index) => (
            <List.Item
              className={`domain-search-result${
                result.Availability !== 'AVAILABLE' ? ' domain-unavailable' : ''
              }`}
              key={result.DomainName}
              onClick={() => this.handleDomainClick(results[index])}
            >
              <List.Content className="domain-search-result-label">
                {result.DomainName}
              </List.Content>
              {result.Availability === 'AVAILABLE' ? (
                <List.Content>
                  <p className="green-color domain-search-free-label">FREE</p>
                </List.Content>
              ) : (
                <List.Content>
                  <p className="red-color domain-search-free-label">Unavailable</p>
                </List.Content>
              )}
            </List.Item>
          ))}
        </List>
        {results.length > 0 && numShowResults !== results.length && (
          <Button onClick={this.showMoreResults} className="centered-button more-results-button">
            Load more results
          </Button>
        )}
      </React.Fragment>
    );
  }
}

export default DomainSearchForm;
